import { Injectable } from '@angular/core';
import { HttpUrlEncodingCodec } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() {
  }

  goToUrl(path: string): void {
    window.location.replace(path);
  }

  openUrlInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  getHref(): string {
    return window.location.href;
  }

  getTenantFromUrl(): string {
    return window.location.pathname.split('/')[1];
  }

  encodeUrl(url: string): string {
    const codec = new HttpUrlEncodingCodec();
    return codec.encodeValue(url);
  }
}
